import React, { useCallback, useRef } from "react";
import { styled } from "@mui/material/styles";
import Avatar from "../Avatar";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { hasImage, objectToFormData } from '../../utils';
import toast from 'react-hot-toast';
import { updateImage } from '../../sevices/apiUploadImage';
import { localStorageInstance } from '../../utils/localStorage';
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import "./uploadImageAvtar.scss";
import { useParams } from "react-router-dom";
import useToastPromise from "../../hooks/useToast";
import { currentUserId } from "../../utils/constants";
import useBoardIdByKey from "../../hooks/useBoardIdByKey";
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function UploadImage({ user, userName, setAnchorEl }) {
  const queryClient = useQueryClient();
  const { id } = useBoardIdByKey();
  const userId = currentUserId();
  const { showToastPromise } = useToastPromise();

  const { mutate: updateImageMutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(updateImage, data);
    } ,
    onSuccess: (res) => {
      // console.log("Worklog Updated successfully");
      queryClient.invalidateQueries({
        queryKey: ["me"],
      });
      queryClient.invalidateQueries({
        queryKey: ["cards", id],
      });
      queryClient.invalidateQueries({
        queryKey: ["boardName", id],
      });
      queryClient.invalidateQueries({
        queryKey: ["boards"],
      });
      queryClient.invalidateQueries({
        queryKey: ["boardUsers", id],
      });
      //   setDisable(false)
      //   // console.log(res)
      //   setLoading(false);
      // reset();
      toast.success("successfully updated");
      setAnchorEl(null);
      // onClose();
      // refetchWorklogDetail();
    },
    onError: (error) => {
      //   setLoading(false);
      //   setDisable(false)
    },
  });

  const upload = useCallback((e) => {
    e.stopPropagation();
  
    const file = e.target.files?.[0];
    if (!file) return;
  
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
  
    if (!allowedTypes.includes(file.type)) {
      toast.error("Choose an Image to upload.");
      e.target.value = "";
      return;
    }

  
    updateImageMutate({
      user_id: userId,
      user_image: file,
    });
  }, [userId, updateImageMutate]);
  

  return (
    <div className="avatar-container">
      <label>
        <VisuallyHiddenInput type="file" accept="image/*" onChange={upload} />
        <Avatar
          user_image={user?.user_image}
          title={`${user?.first_name} ${user?.last_name}`}
          className="user-avatar"
          style={! hasImage(user?.user_image) &&({
            bgcolor: user?.profile_color?.background,
            color: user?.profile_color?.text,
          })}
        >
          {userName}
        </Avatar>
        <div className="icon-overlay">
          {/* <img src={pencilIcon} alt="Edit" /> */}
          <ModeEditOutlinedIcon className="icon-overlay-icon"/>
        </div>
      </label>
    </div>
  );
}

export default React.memo(UploadImage);
